/* eslint-disable max-len */
import React, { useEffect, useState, Suspense, useContext } from 'react';
import CardHeader from '../../../../components/CardHeader';
import TopBarWithShadow from '../../../../components/TopBar/TopBarWithShadow';
import CustomOverLay from '../../../../components/CustomOverlay';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { formatAdjustedDate, formatDateTime } from '../../../../CommonMethods/formatDate';
import { dataService } from '../../../../services/data.services';
import GlobalContext from '../../../../components/Context/GloablContext';
import Loader from '../../../../components/Loader';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';

const ItemsTable = React.lazy(() => import('./components/ItemsTable'));
const AppliedVouchers = React.lazy(() => import('./components/AppliedVouchers'));

const FeeCollectionDetails = () => {
    let {id} = useParams();
    const [loading, setLoading] = useState(false);
    const [feeCollectionDetails, setFeeCollectionDetails] = useState()
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { setToastmessage, setToastErrorMessage } = useContext(GlobalContext);

    const getViewFeeCollectionDetails = async (filter = null, search = null) => {
        try {
            const branch_id = await GetBranchId();
            let feeCollectionId = encodeURIComponent(id);
            setLoading(true);

            let endpoint = `collect-fees/view-fee-report?_id=${feeCollectionId}&branch_id=${branch_id}`;
    
            const response = await dataService.GetAPI(endpoint);
            setFeeCollectionDetails(response?.data?.data?.data);
            console.log()
        } catch (error) {
            navigate('/404');
            console.error(error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }
    const handleFileDownload = async (fee, index) => {
        setDownloadLoading(true)
        try {
            let feeCollectionId = encodeURIComponent(id);
            const branch_id = await GetBranchId();
            const res = await dataService.GetAPI(`collect-fees/download/${feeCollectionId}/${branch_id}`)
            window.open(res.data.data.pre_signed_url, '_blank');
            setToastmessage("Fee Receipt downloaded successfully");
        } catch (error) {
            console.error('An error occurred:', error);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        } finally{
            setDownloadLoading(false);
        }
    }
    useEffect(() => {
        getViewFeeCollectionDetails();
    }, []);    

    // Determine label for Collection Amount based on entry_type
    const getCollectionLabel = () => {
        if (feeCollectionDetails?.entry_type === 'RTE') {
            return 'RTE ';
        }
        else if (feeCollectionDetails?.entry_type === 'Scholarship') {
            return 'Scholarship ';
        }
        else if (feeCollectionDetails?.entry_type === 'Discount') {
            return 'Discount ';
        }
        else if (feeCollectionDetails?.entry_type === 'Write-off') {
            return 'Write-off ';
        }
        return 'Receipt ';
    };

    
    const getCollectionAmountLabel = () => {
        const label = getCollectionLabel();
        if (label.trim() === 'Scholarship') return 'SSH';
        return label;
    };

    return (
        <CardHeader noPadding>
            <TopBarWithShadow
                Tittle="Receipt Details"
                isback={true}
                backLocation={`/student-master/fee-collection?${searchParams.toString()}`}
                rightContent={
                    <button id='view_grn_details_btn' className={`view-actn-btn`} onClick={handleFileDownload} style={{'min-width': '110px'}}>
                        {downloadLoading ? <Loader colorCode='#106EB4'/> : "Download"}
                    </button>
                }
            />
            <Suspense fallback={<CustomOverLay Active text="Loading..." classKey="flex flex-col justify-center items-center sidebarOpenedOverlay" />}>
                {loading ? (
                    <CustomOverLay Active text="Loading..." classKey="flex flex-col justify-center items-center sidebarOpenedOverlay" />
                ) : (
                    <div className="mainDataCntnrPageDiv scrollBlue_thick">
                        <div className="border rounded border-[#D0D5DD]  p-3 mb-6 2xl:w-[70%] xl:w-[85%] m-auto bg-white">
                            <div className="-mx-2 flex w-full">
                                <div className="w-[50%] px-2 " >
                                    <div className="flex mb-4 gap-4">
                                        <span className="w-[135px]" id='po_amount_label'>Student Name</span>
                                        <span className="font-semibold break-all" id='po_amount'>{feeCollectionDetails?.student_name || "-"}</span>
                                    </div>
                                    <div className="flex mb-4 gap-4">
                                        <span className="w-[135px]" id='po_amount_label'>Record ID</span>
                                        <span className="font-semibold break-all" id='po_amount'>{feeCollectionDetails?.student_id || "-"}</span>
                                    </div>
                                    <div className="flex mb-4 gap-4">
                                        <span className="w-[135px]" id='po_amount_label'>{getCollectionAmountLabel()} Amount</span>
                                        <span className="font-semibold break-all" id='po_amount'>{feeCollectionDetails?.received_amount || "-"}</span>
                                    </div>
                                    {feeCollectionDetails?.due_amount && (
                                        <div className="flex mb-4 gap-4">
                                            <span className="w-[135px]" id='po_amount_label'>Pending Amount</span>
                                            <span className="font-semibold break-all" id='po_amount'>{feeCollectionDetails?.due_amount || "-"}</span>
                                        </div>)
                                    }
                                    <div className="flex mb-4 gap-4">
                                        <span className="w-[135px]" id='po_amount_label'>Collection Date</span>
                                        <span className="font-semibold break-all" id='po_amount'>{formatAdjustedDate(feeCollectionDetails?.received_date) || '-'}</span>
                                    </div>
                                    <div className="flex gap-4">    
                                        <span className="w-[135px]" id='po_amount_label'>Added Date</span>
                                        <span className="font-semibold break-all" id='po_amount'>{formatDateTime(feeCollectionDetails?.created_at) || '-'}</span>
                                    </div>
                                </div>
                                <div className="w-[50%] pl-5">
                                    <div className="flex mb-4 gap-4">
                                        <span className="w-[120px]" id='po_amount_label'>Receipt #</span>
                                        <span className="font-semibold break-all" id='po_amount'>{feeCollectionDetails?.receipt_number || "-"}</span>
                                    </div>
                                    <div className="flex mb-4 gap-4">
                                        <span className="w-[120px]" id='po_amount_label'>Collection Type</span>
                                        <span className="font-semibold break-all" id='po_amount'>{feeCollectionDetails?.entry_type || "Receipt"}</span>
                                    </div>
                                    <div className="flex mb-4 gap-4">
                                        <span className="w-[120px] bg" id='po_amount_label'>Ledger Name</span>
                                        <span className="font-semibold break-all  w-[300px]" id='po_amount'>{feeCollectionDetails?.ledger_name || "-"}</span>
                                    </div>
                                    <div className="flex mb-4 gap-4">
                                        <span className="w-[120px]" id='po_amount_label'>Reference #</span>
                                        <span className="font-semibold break-all" id='po_amount'>{feeCollectionDetails?.reference_number || "-"}</span>
                                    </div>
                                    <div className="flex mb-4 gap-4">
                                        <span className="w-[120px]" id='po_amount_label'>Notes</span>
                                        <span className="font-semibold break-all" id='po_amount'>{feeCollectionDetails?.notes || "-"}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {feeCollectionDetails?.payment_details?.length > 0 && (
                            <div className="mt-[30px]  2xl:w-[70%] xl:w-[85%] mx-auto">
                                <span className="font-semibold text-xl mb-1 flex">Cleared Invoices</span>
                                <ItemsTable
                                    feeCollectionDetails={feeCollectionDetails}
                                    items={feeCollectionDetails?.payment_details} 
                                    invoice_type={"inventory"}    
                                /> 
                            </div>
                        )}


                        {feeCollectionDetails?.scheme_payment_details?.length > 0 && (
                            <div className="mt-[30px]  2xl:w-[70%] xl:w-[85%] mx-auto">
                                <span className="font-semibold text-xl mb-1 flex">Applied Vouchers</span>
                                <AppliedVouchers
                                    items={feeCollectionDetails?.scheme_payment_details} 
                                    invoice_type={"inventory"}    
                                /> 
                            </div>
                        )}
                    </div>
                )}
            </Suspense>
        </CardHeader>
    );
};



export default FeeCollectionDetails